import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
// Remove on navx-1834-refactor-resolved-hyperlink cleanup
var withErrorBoundary = function withErrorBoundary(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      fallback: null
    }, /*#__PURE__*/React.createElement(Component, props));
  };
};
export default withErrorBoundary;